<template>
  <div class="ui bottom tab segment" data-tab="basic">
    <form class="ui form" :class="{'loading': form.waiting, 'warning': form.hasErrors()}">
      <div class="field">
        <button type="button" class="ui positive button" @click="save()" :class="{'loading': form.waiting}">保存する</button>
      </div>
      <basic-shop :form="form"></basic-shop>
    </form>
  </div>
</template>

<script>
import BasicShop from './basicShop.vue';

export default {
    components: {
        BasicShop: BasicShop,
    },
    props: {
        form: {
            required: true
        },
    },
    methods: {
        save: function() {
            this.$emit('save');
        }
    }
};
</script>
